import * as B from '@blueprintjs/core';
import classnames from 'classnames';
import React from 'react';

import {TagSetting} from 'app/modules/Remote/Organization';
import {getTextContrastColor} from 'app/utils/colorUtils';

import cs from './MultiFeatureAnalysisTable.module.scss';
import {TagFilter} from '../utils/chartUtils';

export const TagFilterMenu: React.FC<{
  tagFilterMode: TagFilter['tagFilterMode'];
  tagIds: string[];
  tagIdsDict: Record<string, TagSetting>;
  applyTagFilter: (tagIds: string[], tagFilterMode: TagFilter['tagFilterMode']) => void;
}> = ({tagFilterMode, tagIds, tagIdsDict, applyTagFilter}) => {
  return (
    <div className={cs.tagFilterMenuContainer}>
      <div className={cs.tagFilterDescription}>
        <span>Show properties with</span>
        <B.ButtonGroup>
          <B.Button
            text="any"
            active={tagFilterMode === 'any'}
            onClick={() => applyTagFilter(tagIds, 'any')}
            small
          />
          <B.Button
            text="all"
            active={tagFilterMode === 'all'}
            onClick={() => applyTagFilter(tagIds, 'all')}
            small
          />
          <B.Button
            text="none"
            active={tagFilterMode === 'none'}
            onClick={() => applyTagFilter(tagIds, 'none')}
            small
          />
        </B.ButtonGroup>
        <span>of the following tags:</span>
      </div>
      <div className={cs.tagFilterMenu}>
        <div className={cs.tagItemsContainer}>
          {Object.keys(tagIdsDict).map((tagId) => {
            const isSelected = tagIds.includes(tagId);
            return (
              <div
                key={tagId}
                onClick={() => {
                  const newSelectedTags = tagIds.includes(tagId)
                    ? tagIds.filter((id) => id !== tagId)
                    : [...tagIds, tagId];
                  applyTagFilter(newSelectedTags, tagFilterMode);
                }}
                className={classnames(cs.tagItem, {
                  [cs.tagSelected]: isSelected,
                })}
                style={{
                  backgroundColor: tagIdsDict[tagId].color,
                  color: getTextContrastColor(tagIdsDict[tagId].color),
                }}
              >
                <span
                  className={B.Classes.TEXT_OVERFLOW_ELLIPSIS}
                  style={{maxWidth: '150px'}}
                  title={tagIdsDict[tagId].text}
                >
                  {tagIdsDict[tagId].text}
                </span>
                {isSelected && <B.Icon icon="tick" className={cs.tagItemIcon} size={14} />}
              </div>
            );
          })}
        </div>
      </div>
      <B.Button
        onClick={() => applyTagFilter([], 'any')}
        minimal
        className={cs.tagFilterResetButton}
        disabled={tagIds.length === 0 && tagFilterMode === 'any'}
      >
        Reset
      </B.Button>
    </div>
  );
};
